import React from 'react';
import { Link } from 'react-router-dom';

// Official Kitxens brand mark — fork-and-cloud, hosted locally for performance + reliability.
const LOGO_URL = '/kitxens-logo.png';

// Premium inline cloud mark — transparent background, no white box.
// Kept for places where an inline SVG is preferred (dashboard center circle, loaders).
export function KitxensCloud({ className = '', gradient = true }) {
  const fill = gradient ? 'url(#kx-grad)' : '#F77F11';
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg">
      {gradient && (
        <defs>
          <linearGradient id="kx-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#F77F11" />
            <stop offset="100%" stopColor="#FF9B4A" />
          </linearGradient>
        </defs>
      )}
      <path
        fill={fill}
        d="M51 49c5.5 0 10-4.3 10-9.6 0-5.1-4.2-9.3-9.4-9.6C50 22.4 43.3 17 35.5 17c-8.2 0-15 5.9-16.3 13.6C12 31.3 7.5 35.6 7.5 41c0 4.4 3.6 8 8.1 8H51Z"
      />
      <path
        stroke="#ffffff"
        strokeWidth="2.2"
        strokeLinecap="round"
        d="M26.5 31v12M26.5 31c-2 0-3.5 1.6-3.5 3.5V37h7v-2.5c0-1.9-1.5-3.5-3.5-3.5ZM37.5 31v12M37.5 31c2.5 0 4.5 2 4.5 4.5S40 40 37.5 40"
      />
    </svg>
  );
}

// Official PNG brand mark — fork-and-cloud, transparent background where the
// image was prepared so it sits cleanly on both light and dark surfaces.
export function KitxensMark({ className = '', alt = 'Kitxens' }) {
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      className={className}
      loading="eager"
      decoding="async"
      data-testid="kitxens-brand-mark"
    />
  );
}

export default function Logo({ variant = 'dark', withWordmark = true, className = '' }) {
  const isLight = variant === 'light';
  const text = isLight ? 'text-white' : 'text-neutral-900';

  return (
    <Link
      to="/"
      onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
      className={`group flex items-center gap-2.5 shrink-0 ${className}`}
      aria-label="Kitxens home"
      data-testid="brand-home-link"
    >
      <KitxensMark className="h-9 w-9 rounded-lg object-cover transition-transform duration-300 ease-out group-hover:scale-110 group-hover:-rotate-6" />
      {withWordmark && (
        <span className={`font-semibold tracking-[-0.01em] text-[19px] ${text}`}>
          kit<span className="text-[#F77F11] inline-block transition-transform duration-300 group-hover:scale-125 group-hover:rotate-12">x</span>ens
        </span>
      )}
    </Link>
  );
}

export { LOGO_URL };
